import { history } from 'instantsearch.js/es/lib/routers'
import ApiService from '@bodeboca/api'
import CommonUtils from '@bodeboca/utils'

export default class RouterService {

  public static defaultRouter = {
    router: history({
      createURL({ qsModule, routeState, location }) {
        return RouterService.createDefaultUrl(qsModule, location, routeState)
      },
    }),
    stateMapping: {
      stateToRoute(uiState: any) {
        const indices = Object.keys(uiState)
        if(indices.length > 0) {
          const index = indices[0]
          const generalIndex = RouterService.generalizeIndex(index)
          delete uiState[index]['configure']
          uiState[generalIndex] = uiState[index]
          if(uiState[generalIndex]['sortBy']) {
            uiState[generalIndex]['sortBy'] = RouterService.generalizeIndex(uiState[generalIndex]['sortBy'])
          }
          delete uiState[index]
        }
        return uiState

      },
      routeToState(routeState: any) {
        const indices = Object.keys(routeState)
        if(indices.length > 0) {
          const index = indices.find((element) => element.indexOf('algolia_index') !== -1)
          if(index !== undefined) {
            const builtIndex = RouterService.buildIndex(index)
            routeState[builtIndex] = routeState[index]
            if (routeState[builtIndex]['sortBy']) {
              routeState[builtIndex]['sortBy'] = RouterService.buildIndex(routeState[builtIndex]['sortBy'])
            }
            delete routeState[index]
          }
        }
        return routeState
      },
    },
  }


  public static getRouter() {

    if (ApiService.getRoutingContext() === 'flechazos') {

      return {
        ...RouterService.defaultRouter,
        router: history({
          createURL({ qsModule, routeState, location }) {

            return RouterService.createURL(qsModule, routeState)
          }, parseURL({ qsModule, location }) {

            return RouterService.parseUrl(qsModule, location)
          },
        }),

      }
    }

    return RouterService.defaultRouter
  }

  public static createDefaultUrl(qsModule, location, routeState) {
    let routeStateKeys = Object.keys(routeState)
    let indexName = routeStateKeys.find((element) => element.indexOf('algolia_index') !== -1)
    let indexState = {}
    if(indexName) {
      indexState = routeState[indexName]
    }
    const { origin, pathname, hash, search } = location
    const queryParameters = qsModule.parse(search.slice(1)) || {}
    if (Object.keys(indexState).length) {
      Object.assign(queryParameters, routeState)
    } else {
      delete queryParameters[ApiService.getDefaultIndex()]
    }
    let queryString = qsModule.stringify(queryParameters)

    if (queryString.length) {
      queryString = `?${queryString}`
    }

    return `${origin}${pathname}${queryString}${hash}`
  }

  public static createURL(qsModule, routeState) {

    const context = RouterService.getContextSettings()
    const urlMappings = context['url_mappings']
    const indexState = routeState['algolia_index'] || {}
    const { origin, pathname, hash, search } = location
    const queryParameters = qsModule.parse(search.slice(1)) || {}
    let prefix = ApiService.getPathPrefix()
    let returnRoute =  '/' + prefix + context['base_url']
    let slugs = []
    let processedRefinements = []
    let multiValuePresent = false
    for (let i = 0; i < urlMappings.length; i++) {
      const type = urlMappings[i]['type']
      const attribute = urlMappings[i]['attribute']
      if (routeState && routeState['algolia_index'] && routeState['algolia_index'][type]) {
        let value = routeState['algolia_index'][type][attribute]
        if (value === undefined) {
          break
        }
        if (value.length > 1) {
          multiValuePresent = true
        }
        let slug = ApiService.translateIdToSlug('flechazo_user', value[0])
        slugs.push(slug)
        processedRefinements.push(attribute)
      }
    }
    if (!multiValuePresent && routeState['algolia_index']['refinementList'] !== undefined && Object.keys(routeState['algolia_index']['refinementList']).length === processedRefinements.length) {
      delete routeState['algolia_index']['refinementList']
    }
    if (slugs.length > 0) {
      returnRoute = returnRoute + '/' + slugs.join('/')
    }

    if (Object.keys(indexState).length) {
      Object.assign(queryParameters, routeState)
    } else {
      delete queryParameters['algolia_index']
    }
    let queryString = qsModule.stringify(queryParameters)
    if (queryString.length) {
      queryString = `?${queryString}`
    }

    return returnRoute += queryString
  }

  public static parseUrl(qsModule, location) {
    const context = RouterService.getContextSettings()
    let decodedObject = {}
    decodedObject = qsModule.parse(location.search.slice(1), {})
    if (decodedObject['algolia_index'] === undefined) {
      decodedObject = {
        ['algolia_index']: {
          refinementList: {},
        },
      }
    }

    let splitedUrl = location.pathname.split(context['base_url'] + '/')
    let urlParts = []

    if (splitedUrl[1]) {
      const urlMappings = context['url_mappings']
      urlParts = splitedUrl[1].split('/')
      for (let i = 0; i < urlParts.length; i++) {
        const slug = decodeURI(urlParts[i])
        const type = urlMappings[i]['type']
        const attribute = urlMappings[i]['attribute']
        const translatedSlug = ApiService.translateSlugToId(attribute, slug)
        // Init if empty.
        if (decodedObject['algolia_index'][type] === undefined) {
          decodedObject['algolia_index'][type] = {
            [attribute]: [],
          }
        } else if (decodedObject['algolia_index'][type][attribute] === undefined) {
          decodedObject['algolia_index'][type][attribute] = []
        }
        decodedObject = {
          ['algolia_index']: {
            ...decodedObject['algolia_index'], [type]: {
              ...decodedObject['algolia_index'][type], [attribute]: [...decodedObject['algolia_index'][type][attribute], translatedSlug],
            },
          },
        }

      }
    }
    return decodedObject
  }

  public static getContextSettings(): object {
    let context = ApiService.getRoutingContext()
    let contextObject = {}
    if (drupalSettings['algolia']['context_config'][context] !== undefined) {
      contextObject = drupalSettings['algolia']['context_config'][context]
      let urlMappings = contextObject['url_mappings']
      if (contextObject['url_mappings'] !== undefined) {
        for (let i = 0; i < urlMappings.length; i++) {
          urlMappings[i]['attribute'] = CommonUtils.replacePlaceholders(urlMappings[i]['attribute'])
        }
        contextObject['url_mappings'] = urlMappings
      }
    }
    return contextObject
  }

  public static generalizeIndex(index: string) {
    const regex = /store_\d+_(?:\w+_)*(authenticated|is_premium|b2b)_(.*)/
    const match = index.match(regex)

    if (match) {
      const [, role, rest] = match

      return `algolia_index_${rest}`
    }

    return 'algolia_index'
  }
  public static buildIndex (index:string): string {
    const defaultIndex = ApiService.getDefaultAutocompleteIndex()
    if (index === 'algolia_index') {
      return defaultIndex
    }
    else {
      index = index.replace('algolia_index', defaultIndex)
      return index
    }

  }
}
